import { customerMarketShopfrontJobsApi } from '@envato/foundation-types'

const INAPPROPRIATE_TAGS = [
  'bdsm',
  'cocaine',
  'heroin',
  'marijuana',
  'naked',
  'nude',
  'nudity',
  'sex',
  'suicide'
]

export default (
  searchResults: Readonly<customerMarketShopfrontJobsApi.IBaseResult>
): customerMarketShopfrontJobsApi.IBaseResult => {
  const filteredMatches = searchResults.matches.filter(match => {
    const inappropriateTagFound = match.tags.reduce(
      (inappropriate: boolean, tag: string): boolean => {
        return inappropriate ? inappropriate : INAPPROPRIATE_TAGS.includes(tag)
      },
      false
    )

    return !inappropriateTagFound
  })

  return {
    ...searchResults,
    matches: filteredMatches
  }
}
